import { DialogEnum } from '../components/messages/messages.enum';
import { DialogOption } from './dialog-option.model';

export class Dialog {
    public type: DialogEnum = DialogEnum.Normal;
    public title: string = "";
    public message: string = "";
    public options: Array<DialogOption> = [];
    /** Si es true, el mensaje se renderiza como HTML ([innerHTML]). */
    public useHtmlMessage?: boolean;
    /** Si es true, los botones del footer tienen el mismo ancho. */
    public equalButtonWidth?: boolean;
    /** Si es true, los botones se apilan en columna (arriba/abajo). */
    public stackButtons?: boolean;

    constructor(init?: Partial<Dialog>) {
        Object.assign(this, init);
    }
}
